import { BaseService } from '@/infra/services/base-service';
import { Sector } from '@/types/entities/Sector';
import { GetSectorsMapper } from '@/core/mapper/sector';
import { GetSectorsRequestDTO, GetSectorsResponseDTO } from '@/core/dto/sector/get-sectors';
import type { SelectOption } from '@/components/ui/SelectOptions/types';

export class SectorService extends BaseService<Sector> {
	private static instance: SectorService;

	private constructor(public readonly basePath: string = '/sector') {
		super();
	}

	public static getInstance(): SectorService {
		if (!SectorService.instance) {
			SectorService.instance = new SectorService();
		}
		return SectorService.instance;
	}

	public async listOptions(params: GetSectorsRequestDTO): Promise<Sector[]> {
		const url = this.basePath + `/${params.organization_id}/${params.company_id}`;
		const { data } = await this.getInstance().get(url);
		return data;
	}

	public async getSectors(params: GetSectorsRequestDTO): Promise<SelectOption[]> {
		const url = this.basePath + `/${params.organization_id}/${params.company_id}`;
		const { data } = await this.getInstance().get<GetSectorsResponseDTO>(url);
		return new GetSectorsMapper(data).toDomain();
	}
}
